// Supplied brand assets (primary visual identity) + curated supplemental imagery.
export const LOGO = "/assets/asset3.png";        // gold-on-black The D logo
export const NEON_SIGN = "/assets/asset2.png";   // "Never forget the difference you make"
export const POOL_NIGHT = "/assets/asset1.png";  // electric blue night pool (PRIMARY hero)

export const GALLERY = [
  { src: POOL_NIGHT, caption: "The pool after dark", tall: true },
  { src: NEON_SIGN, caption: "Never forget the difference you make" },
  { src: "https://images.pexels.com/photos/35225829/pexels-photo-35225829.jpeg", caption: "Warm light through ivory curtains" },
  { src: "https://images.unsplash.com/photo-1782936875912-0c500484e5e4", caption: "Poolside palms" },
  { src: "https://images.pexels.com/photos/6309847/pexels-photo-6309847.jpeg", caption: "The social house, aglow" },
  { src: "https://images.unsplash.com/photo-1707589338014-cb60c7e74471", caption: "The bar at the water's edge" },
];

export const SECTION_IMG = {
  curtains: "https://images.pexels.com/photos/35225829/pexels-photo-35225829.jpeg",
  palms: "https://images.unsplash.com/photo-1782936875912-0c500484e5e4",
  interior: "https://images.pexels.com/photos/6309847/pexels-photo-6309847.jpeg",
  bar: "https://images.unsplash.com/photo-1707589338014-cb60c7e74471",
};

export const SIGNATURE = "Never Forget the Difference You Make";
